
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolios",
      function () {
        return require("private-next-pages/portfolios/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolios"])
      });
    }
  